import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

export default function SpreadsheetPreview({ file }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!file) return;

    const load = async () => {
      let data;

      if (file instanceof File) {
        data = await file.arrayBuffer();
      } else {
        const response = await fetch(file.file_url || file.download_url);
        data = await response.arrayBuffer();
      }

      const workbook = XLSX.read(data, { type: "array" });

      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      const json = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
      });

      setRows(json);
    };

    load();
  }, [file]);

  if (!rows.length) return <p>Loading...</p>;

  return (
    <div
      style={{
        overflow: "auto",
        maxHeight: 600,
      }}
    >
      <table className="table">
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>{String(cell ?? "")}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
